import loadCSSVariablesPolyfill from './cssVariables';

export default function loadPolyfills() {
  loadCSSVariablesPolyfill();
}
